import request from "root/js/request";

const getPostingCancellationWidgetsOzon = async ({ wb_api_key_ids, date_from, date_to }) => {
  const response = await request({
    url: "/ozon_analytics/posting_cancellation_widgets/",
    method: "get",
    params: {
      wb_api_key_ids,
      date_from,
      date_to,
    },
  });
  return response.data;
};

export { getPostingCancellationWidgetsOzon };
